import React from "react";
import { changeLanguage, supportedLanguages } from "../../i18n";

const changeLang = (lang) => {
  changeLanguage(lang);
};

const Langswitcher = () => {
  return (
    <>
      <div className="locale-change">
        {supportedLanguages.map((supportedLanguage) => (
          <div
            className={"locale-flag locale-flag-" + supportedLanguage}
            onClick={() => changeLang(supportedLanguage)}
          ></div>
        ))}
      </div>
    </>
  );
};

export default Langswitcher;
